import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { postAsync } from '../../../components/helper/axiosHelper';
import { useLocation } from 'react-use';
import { PageHitCountApi } from '../../../shared/Helper';
import { toast } from 'react-toastify';
import { z } from 'zod';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';

export const Changepassword = () => {
  const isActive = useSelector((state) => state.toggle.isActive);
  const [newpassword, setNewpassword] = useState('');
  const [cpassword, setCpassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [formerror, setFormerror] = useState({});
  const [isExpired, setIsExpired] = useState(false);

  const { forgetGUID } = useParams();
  const { t } = useTranslation();

  const navigate = useNavigate();

  const user = z.object({
    newPassword: z
      .string()
      .min(8, 'Must be 8 or more characters long')
      .refine((value) => /[0-9]/.test(value), 'Must contain at least one number')
      .refine((value) => /[a-z]/.test(value), 'Must contain at least one lowercase letter')
      .refine((value) => /[A-Z]/.test(value), 'Must contain at least one uppercase letter'),
    confirmPassword: z.string().refine((value) => value === newpassword, 'Passwords must match', true),
  });

  const togglePasswordVisibility = async () => {
    setShowPassword(!showPassword);
  };

  const passChangeBody = {
    newPassword: newpassword,
    confirmPassword: cpassword,
  };

  const { pathname } = useLocation();

  useEffect(() => {
    PageHitCountApi(pathname, 0);
  }, []);

  const handlePassChange = async (e) => {
    e.preventDefault();
    const parseuser = user.safeParse(passChangeBody);
    if (!parseuser.success) {
      const error = parseuser.error;
      let newerror = {};
      for (const issue of error.issues) {
        newerror = { ...newerror, [issue.path]: issue.message };
      }
      return setFormerror(newerror);
    } else {
      await postAsync(`EP_UserAuthentication/EP_UserChangePassword`, passChangeBody, {
        referralLink: forgetGUID,
      })
        .then((response) => {
          if (response?.statusCode == 200) {
            navigate('/donorLogin');
            toast.success(`${t(`${response?.message}`)}`);
          } else {
            toast.error(`${t(`${response?.message}`)}`);
          }
        })
        .catch((err) => {
          toast.error(t(`Something went wrong, Please try again!`));
        });
    }
  };

  useEffect(() => {
    localStorage.setItem('isHome', true);
    handleExpiry();
  }, []);

  const handleExpiry = async () => {
    await postAsync(`EP_UserAuthentication/ForgetLinkExpiryValidation`, {}, { referralLink: forgetGUID })
      .then((response) => {
        if (response.statusCode === 410) {
          setIsExpired(true);
        }
      })
      .catch((err) => {
        console.log(err);
        toast.error(t('Something went wrong, Please try again!'));
      });
  };

  return !isExpired ? (
    <div data-aos="zoom-in" data-aos-easing="linear" data-aos-duration="1500" className="pt-12  xl:pt-28 items-center">
      <div
        className="py-10"
        style={{
          background: `transparent url('./assets/Sharjah-stroke-logo-1.png') left top 0px no-repeat`,

          width: '100%',
        }}
      >
        {' '}
      </div>
      <div className="container-fluid ">
        <div className="row justify-center  items-center">
          <div className=" col-lg-4   col-sm-6 ">
            <form onSubmit={handlePassChange} className="container max-w-screen-sm py-4">
              <div className="card rounded-4xl shadow-customgreen bg-green-50">
                <div className="card-body">
                  <div className="row justify-center items-center">
                    <div className=" flex justify-center">
                      <div className="w-24 h-24  flex items-center justify-center rounded-full border-2 border-customgreen">
                        <svg
                          version="1.0"
                          xmlns="http://www.w3.org/2000/svg"
                          width="50.000000pt"
                          height="50.000000pt"
                          viewBox="0 0 290.000000 350.000000"
                          preserveAspectRatio="xMidYMid meet"
                        >
                          {' '}
                          <g
                            transform="translate(0.000000,300.000000) scale(0.050000,-0.050000)"
                            fill="#1d8b4b"
                            stroke="none"
                          >
                            {' '}
                            <path d="M2680 5960 c-187 -44 -329 -94 -420 -149 -38 -23 -97 -55 -129 -71 -110 -55 -416 -382 -498 -530 -629 -1145 264 -2509 1542 -2356 1139 136 1749 1342 1192 2356 -82 148 -388 475 -498 530 -32 16 -90 48 -129 72 -266 161 -728 226 -1060 148z" />{' '}
                            <path d="M2370 2467 c-1099 -158 -1942 -1062 -1985 -2129 l-10 -251 55 -44 55 -43 2515 0 2515 0 55 43 55 44 -10 251 c-31 769 -460 1444 -1195 1876 -103 60 -365 158 -560 209 -164 42 -1273 75 -1490 44z" />{' '}
                          </g>{' '}
                        </svg>
                      </div>
                    </div>
                  </div>
                  <div className="row justify-center items-center">
                    <div className="col-lg-6 w-auto text-center">
                      <h2 className="text-xl text-customgreen  font-semibold">{t('Reset Password')}</h2>
                    </div>
                  </div>
                  <div className="form-group">
                    <label>
                      {t('New Password')}
                      <span className="errmsg">*</span>
                    </label>
                    <input
                      value={newpassword}
                      onChange={(e) => setNewpassword(e.target.value)}
                      placeholder={t('New Password')}
                      className="border border-customgreen focus:ring-customgreen text-gray-900 text-sm rounded-lg  block w-full p-2.5"
                      type="password"
                      name="newpassword"
                    />
                  </div>
                  {formerror.newPassword && <p className="text-red-700">{formerror.newPassword}</p>}

                  <div className="form-group">
                    <label>
                      {t('Confirm Password')}
                      <span className="errmsg">*</span>
                    </label>
                    <div style={{ position: 'relative', flex: 1 }}>
                      <input
                        value={cpassword}
                        onChange={(e) => setCpassword(e.target.value)}
                        placeholder={t('Confirm Password')}
                        className="border border-customgreen focus:ring-customgreen text-gray-900 text-sm rounded-lg  block w-full p-2.5"
                        type={showPassword ? 'text' : 'password'}
                        name="cpassword"
                      />
                      <button
                        type="button"
                        className={`eye-button ${isActive ? 'left-1' : 'right-1'}`}
                        style={{
                          backgroundColor: 'transparent',
                          border: '0',
                          position: 'absolute',

                          top: '50%',
                          transform: 'translateY(-50%)',
                        }}
                        onClick={togglePasswordVisibility}
                      >
                        {showPassword ? <VisibilityIcon /> : <VisibilityOffIcon />}
                      </button>
                    </div>
                  </div>
                  {formerror.confirmPassword && <p className="text-red-700">{formerror.confirmPassword}</p>}
                </div>

                <div className="card-footer  flex justify-center  items-center border-0">
                  <button
                    type="submit"
                    className="text-white bg-customgreen hover:bg-hovergreen focus:outline-none focus:ring-4 focus:ring-customgreen font-medium rounded-full text-sm px-5 py-2.5 text-center ms-1"
                  >
                    {t('Submit')}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  ) : (
    <div className="flex flex-col justify-center items-center pt-40 md:pt-28 xl:pt-52">
      <h1 className="text-2xl text-center   text-black">{t('Your link has been expired!')}</h1>
      <Link to="/" className="text-center text-red-600 font-bold underline underline-offset-4">
        {t('Back to Home')}
      </Link>
    </div>
  );
};
